export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14118.39194639.jpg";